import { initials } from '../app/initials'
import type { MechanicLoad } from './overviewMetrics'

/**
 * Auslastung je Mechaniker — ehrlich auf Basis der zugewiesenen aktiven Aufträge. Die echte Auslastung
 * in Prozent (Soll/Ist aus dem Dienstplan) folgt mit dem Zeiterfassungs-Backend; bis dahin steht hier
 * bewusst „kommt bald" statt einer erfundenen Zahl.
 */
export function MechanicWorkload({ loads }: { loads: MechanicLoad[] }) {
  return (
    <div className="wf-ovpanel">
      <h3 className="wf-ovpanel__title">Auslastung je Mechaniker</h3>
      {loads.length === 0 ? (
        <p className="wf-ov-empty">Noch keine Aufträge zugewiesen.</p>
      ) : (
        <ul className="wf-mechlist">
          {loads.map((m) => (
            <li key={m.mechanicId} className="wf-mechrow">
              <span className="wf-mechrow__avatar" aria-hidden="true">
                {initials(m.name)}
              </span>
              <span className="wf-mechrow__main">
                <span className="wf-mechrow__name">{m.name}</span>
                <span className="wf-mechrow__sub">
                  {m.activeCount} {m.activeCount === 1 ? 'aktiver Auftrag' : 'aktive Aufträge'}
                </span>
              </span>
              <span className="wf-mechrow__soon">Auslastung % kommt bald</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
